import { render } from "./timer.vue?vue&type=template&id=c6f0c286"
import script from "./timer.vue?vue&type=script&lang=js"
export * from "./timer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js_old/components/reduction/fields/timer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6f0c286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6f0c286', __exports__)) {
    console.log('reload')
    api.reload('c6f0c286', __exports__)
  }
  
  module.hot.accept("./timer.vue?vue&type=template&id=c6f0c286", () => {
    console.log('re-render')
    api.rerender('c6f0c286', render)
  })

}


export default __exports__